module.exports = __webpack_public_path__ + "assets/deragopyan-alt.cf38a58e.svg";